varying float uSize;
void main(){

    gl_FragColor = vec4(uSize, 0.5, 1.0, 1.0);
}